// ==========================================
// NEW SEARCH ARCHITECTURE - Phase 1
// search-normalizer.js
//
// Pure text-normalization utilities for the new search
// architecture. This module is NOT wired into the site yet.
// It is not loaded by theme.liquid, it attaches no listeners,
// and nothing currently calls it.
//
// It intentionally does NOT touch, read, or modify anything
// used by smart-search.js or predictive-search.js.
// ==========================================

(function (global) {
  "use strict";

  var NewSearch = (global.NewSearch = global.NewSearch || {});

  if (NewSearch.normalizer) {
    // Already defined (e.g. script included twice) - don't redefine.
    return;
  }

  /**
   * Lowercases, strips punctuation, and collapses whitespace.
   * Does not apply any alias/synonym substitution - that is left
   * to the caller so this stays a pure, dependency-free function.
   */
  function normalize(text) {
    var t = String(text || "").toLowerCase();
    t = t.replace(/[^\w\s]/g, " ");
    t = t.replace(/\s+/g, " ").trim();
    return t;
  }

  /**
   * Splits a normalized string into non-empty tokens.
   */
  function tokenize(text) {
    var normalized = normalize(text);
    if (!normalized) return [];
    return normalized.split(" ").filter(Boolean);
  }

  /**
   * Applies a simple alias/synonym map to a string before normalizing.
   * aliasMap: { "one plus": "oneplus", ... }
   * This is a generic helper - it does not read any global alias
   * table, so it cannot collide with smart-search.js's ALIASES.
   */
  function applyAliases(text, aliasMap) {
    var t = String(text || "").toLowerCase();
    if (aliasMap) {
      Object.keys(aliasMap).forEach(function (key) {
        t = t.replaceAll(key, aliasMap[key]);
      });
    }
    return t;
  }

  NewSearch.normalizer = {
    normalize: normalize,
    tokenize: tokenize,
    applyAliases: applyAliases,
  };
})(window);
